export interface AccountSettingsTabContent {
    name: string;
    icon: string;
    id: string;
    translateKey?: string;
};